import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../app/common/libs/http';

export function validateUser({ username, password }) {
  return new Promise((resolve) =>
    setTimeout(
      () =>
        resolve({
          data: {
            username,
            firstName: 'Flecx',
            lastName: 'Insights',
            token: 'This is sample token',
          },
        }),
      1000
    )
  );
}

export const signIn = createAsyncThunk(
  'auth/fetchUser',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_AUTHURL}/Account/login`,
        userData
      );
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const fetchUserByEmail = createAsyncThunk(
  'auth/fetchUserByEmail',
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_APIURL}/user/getByEmail/${email}`
      );
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const forgotPassword = createAsyncThunk(
  'auth/forgotPassword',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_AUTHURL}/Account/forgotpassword`,
        userData
      );
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const resetPassword = createAsyncThunk(
  'auth/resetPassword',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_AUTHURL}/Account/resetpassword`,
        userData
      );
      return response.data;
    } catch (err) {
      if (err.response.data.errors) {
        if (err.response.data.errors.ConfirmPassword)
          return rejectWithValue({
            Errors: err.response.data.errors.ConfirmPassword,
          });
      }
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);

export const changePassword = createAsyncThunk(
  'auth/changePassword',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_AUTHURL}/Account/changePassword`,
        userData
      );
      return response.data;
    } catch (err) {
      if (err.response.data.errors) {
        if (err.response.data.errors.ConfirmPassword)
          return rejectWithValue({
            Errors: err.response.data.errors.ConfirmPassword,
          });
      }
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);

//For onBoarding User Account
export const createAccount = createAsyncThunk(
  'accountCreate',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}/Account`,
        data
      );
      return response.data;
    } catch (err) {
      if (err.response.data.errors) {
        if (err.response.data.errors.Account)
          return rejectWithValue({ Errors: err.response.data.errors.Account });
      }
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const editAccount = createAsyncThunk(
  'accountCreate',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}/Account/update`,
        data
      );
      return response.data;
    } catch (err) {
      if (err.response.data.errors) {
        if (err.response.data.errors.Account)
          return rejectWithValue({ Errors: err.response.data.errors.Account });
      }
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const resendVerificationEmail = createAsyncThunk(
  'accountCreate',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}/Account/resendEmail`,
        data
      );
      return response.data;
    } catch (err) {
      if (err.response.data.errors) {
        if (err.response.data.errors.Account)
          return rejectWithValue({ Errors: err.response.data.errors.Account });
      }
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const verifyToken = createAsyncThunk(
  'verifytoken',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}/Account/verifyToken`,
        data
      );
      return response.data;
    } catch (err) {
      if (err.response.data.errors) {
        if (err.response.data.errors.Account)
          return rejectWithValue({ Errors: err.response.data.errors.Account });
      }
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue({
        Errors: err.response.data || 'Some error occurred',
      });
    }
  }
);
export const updateAccountDetails = createAsyncThunk(
  'accountUpdateDetails',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}/Account/updateDetails`,
        data
      );
      return response.data;
    } catch (err) {
      if (err.response.data.errors) {
        if (err.response.data.errors.Account)
          return rejectWithValue({ Errors: err.response.data.errors.Account });
      }
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);

export const logoutUser = createAsyncThunk(
  'auth/logout',
  async () =>
    await axios.post(`${process.env.REACT_APP_AUTHURL}/Account/logout`)
);
